import "./OurPhilosophy.module.css";
import Header from "@/reusable_sections/Header";
import APledgeOfIndependence from "./sections/APledgeOfIndependence";
import Footer from "@/reusable_sections/Footer";
export default function OurPhilosophyPage() {
  return <div>
      <Header />
      <APledgeOfIndependence />
      <Footer />
    </div>;
}